module.exports = __webpack_public_path__ + "img/32.91b7bf81.jpg";